import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

import * as Highcharts from 'highcharts';
import * as Exporting from 'highcharts/modules/exporting';
Exporting(Highcharts)

import * as _ from 'lodash';
import * as dot from 'dot-object';
declare var $:any;

@Component({
	selector: 'app-cashflow',
	templateUrl: './cashflow.component.html',
	styleUrls: ['./cashflow.component.css']
})
export class CashflowComponent implements OnInit {
	filter_summary = {};
	data_summary;
	filter_bill = {};
	data_bill; bill;
	data_rpt;
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		let date = new Date();
		date.setDate(date.getDate() - 7)
		this.filterSummary({'from':date.toISOString(), 'to': new Date().toISOString()});
	}
	ngAfterViewChecked() {
		$('.text-justify img').addClass('img-fluid');
		$(document).on('focusin', function(e) {
			if ($(e.target).closest(".mce-window").length) {
				e.stopImmediatePropagation();
			}
		});
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}

	filterSummary(filter) {
		if(filter.from && filter.to) {
			this.loadSummary({'deadline':{'between':[filter.from, filter.to]}})
		}
	}
	loadSummary(param = null) {
		let filter = this.filter_bill;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "accountcode": this.appServices.accountcode})
		this.appServices.api('Crmbills/sum', {
			'filter': `{"where":${JSON.stringify(filter)}, "order": "updated_dt desc"}`,
			'prop': 'codelead',
			'type': 'string'
		}, this).then(function(obj){
			let res = obj.response.json().res;
			if(res.length > 0) {
				obj.component.loadChartColumn(res);
				let bills = res.reduce((a,b) => {
					a = a.concat(b.data)
					return a
				}, [])
				obj.component.loadBill(bills)
			} else {
				obj.component.notifyService.show('Empty data', 'danger');
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadBill(data) {
		this.data_bill = data;
	}
	loadChartColumn(data) {
		Highcharts.chart('chartColumn', {
			chart: {
				type: 'bar'
			},
			title: {
				style: {
					display: 'none'
				}
			},
			xAxis: {
				categories: data.map(el => el.lead.name),
				title: {
					text: null
				},
				visible: false
			},
			yAxis: {
				title: {
					text: null
				}
			},
			plotOptions: {
				bar: {
					dataLabels: {
						enabled: true
					}
				}
			},
			legend: {
				layout: 'vertical',
				align: 'right',
				verticalAlign: 'top',
				x: -40,
				y: 80,
				floating: true,
				borderWidth: 1,
				backgroundColor: ((Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'),
				shadow: true
			},
			credits: {
				enabled: false
			},
			series: data.map(el => {
				return {'name': el.lead.name, 'data': [el.amount]}
			})
		});
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/cashflow/cashflow.component.ts